export const qualtricDialogConfig: any = {
  dialogHeight: '680px',
  dialogMaxHeight: '1020px',
  dialogMaxWidth: '880px',
  dialogWidth: '774px',
};

export const qualtricDialogBodyConfig: any = {
  height: '640px',
  'margin-left': '-52px',
  'margin-top': '-64px',
  position: 'fixed',
  top: '129px',
  width: 'auto',
};

export interface IQualtricDialog {
  dialogWidth: string;
  dialogMaxWidth: string;
  dialogHeight: string;
  dialogMaxHeight: string;
}

export interface IQSI {
  [key: string]: any;
}
export interface IQualtricDialogBody {
  height: string;
  width: string;
  marginTop: string;
  marginLeft: string;
  position: string;
  top: string;
}
